import { render } from "./OurEquipmentBigScreen.vue?vue&type=template&id=2a07dc4b"
import script from "./OurEquipmentBigScreen.vue?vue&type=script&lang=js"
export * from "./OurEquipmentBigScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__